import {IStrapiEntity, StrapiUtils} from "services/strapi";
import {ListItemsTable, ListItemsTableProps} from "components/common";
import {RoutesResolver} from "routes";
import {IPurchaseOrder, TableSettings} from "features/purchase-orders";

interface Props extends Omit<ListItemsTableProps<
    IPurchaseOrder & { id: number },
    void>,
    'settings' | 'data'> {

    data?: IStrapiEntity<IPurchaseOrder>[]
}

export function PurchaseOrdersListTable({data, ...rest}: Props){
    const routesResolver = new RoutesResolver()
    return (
        <ListItemsTable
            {...rest}
            data={StrapiUtils.flattenStrapiEntities(data)}
            settings={TableSettings({
                routesResolver,
            })}
        />
    )
}